import { render } from "./App.vue?vue&type=template&id=44d77318"
const script = {}

import exportComponent from "/home/lihe/jtb/WebstormProjects/stp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__